<template>
    <div class="container">

       <div class="loginDiv">
         <h1 style="margin-bottom: 20px">
           进度管控
         </h1>
         <div class="loginForm" >
           <Row>
             <Col :span="5">
               <Row class="leftText">
                 用户名
               </Row>
               <Row class="leftText" style="margin-top: 20px">
                 密码
               </Row>
             </Col>
             <Col :span="18">
               <Row>
                 <Input type="text" clearable v-model.trim="loginForm.username" style="width: 350px"  placeholder="请输入..."/>
               </Row>
               <Row style="margin-top: 20px">
                 <Input type="password" clearable v-model.trim="loginForm.password"  style="width: 350px" placeholder="请输入..."/>
               </Row>
             </Col>
           </Row>

           <!--<Form ref='searchForm' :model="loginForm" :label-width="0" label-position="right" class="basicForm">

             <FormItem class="form-item" label="" >
               用户名
               <Input type="text" clearable v-model.trim="loginForm.username" style="width: 250px"  placeholder="请输入..."/>
             </FormItem>
             <FormItem class="form-item" label="" >
               密码
               <Input type="password" clearable v-model.trim="loginForm.password"  style="width: 250px" placeholder="请输入..."/>
             </FormItem>
             <FormItem class="form-item form-item-button" label=""  >
               <Button class="iconfont" type="primary" @click="goLogin" :loading="loading">&nbsp;登录</Button>
             </FormItem>
           </Form>-->
         </div>
         <Row style="margin-left: 47%;margin-top: 20px">
           <Button class="iconfont" type="primary"  size="large" @click="goLogin"  @keyup.enter="enterSearch" :loading="loading">&nbsp;登录</Button>
         </Row>
       </div>




    </div>
</template>

<script>
  import util from "@/api/util";
  import md5 from 'md5';
  import {
    login,
    userInfo,
  } from "@/api/index";
    export default {
        name: "login",
        data(){
          return {
            loginForm:{},
            loading:false,
          }
        },
      methods:{
        enterSearch(){
          document.onkeydown = e =>{
            //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
            if (e.keyCode === 13 && e.target.baseURI.match(/freshmanage/)) {
              //回车后执行搜索方法
              this.goLogin()
            }
          }
        },
        init() {
          this.param = {
            accessToken: util.getQueryString("accessToken"),
          }
          if (this.param.accessToken != null) {
            window.localStorage.setItem("accessToken", this.param.accessToken);
            //this.setStore("accessToken", this.param.accessToken);
            this.getUserInfo()
          }
          // 绑定enter事件
          this.enterKeyup();
        },
        enterKey(event) {
          const code = event.keyCode ?
            event.keyCode :
            event.which ?
              event.which :
              event.charCode;
          if(code == 13) {
            this.goLogin();
          }
        },
        enterKeyupDestroyed() {
          document.removeEventListener("keyup", this.enterKey);
        },
        enterKeyup() {
          document.addEventListener("keyup", this.enterKey);
        },
        goLogin(){
          if(!this.loginForm.username){
            this.$Message.error('请填写用户名！');
            return false;
          }
          if(!this.loginForm.password){
            this.$Message.error('请填写密码！');
            return false;
          }
          this.loading = true
          login({
            username: this.loginForm.username,
            password: md5(this.loginForm.password),
          }).then(res => {
            if (res.code == 200) {
              window.localStorage.setItem("accessToken", res.data.accessToken);
              this.getUserInfo()
            } else {
              this.loading = false;
            }
          });

        },
        getUserInfo() {
          // 获取用户信息
          userInfo().then(
            res => {
              if (res.code== 200) {
                window.sessionStorage.setItem("userInfo", JSON.stringify(res.data));


                this.$router.push({
                  name: "index"
                });
              } else {
                this.loading = false;
              }
            },
            err => {
              console.log("err", err);
            }
          );
        },
      },
      destroyed() {
        // 销毁enter事件
        this.enterKeyupDestroyed();
      },
      mounted() {
          this.init()
      }
    }
</script>

<style lang="less">
  @import "./login.less";
</style>



// WEBPACK FOOTER //
// src/components/login.vue